import React from "react";
import {
    Button,
    Card,
    CardContent,
    Skeleton,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

export default function DashboardDueTable({loading, nextDue, fmtEUR, safeInvoiceTotal}) {
    return (
        <Card sx={{borderRadius: 3, boxShadow: "0 6px 24px rgba(0,0,0,0.06)"}}>
            <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Offene Rechnungen – nächste Fälligkeiten</Typography>
                    <Button component={RouterLink} to="/invoices" size="small" sx={{color: "orange"}}>
                        zu Rechnungen
                    </Button>
                </Stack>
                <Table size="small" sx={{mt: 1}} aria-label="Nächste Fälligkeiten">
                    <TableHead>
                        <TableRow>
                            <TableCell>Rechnung</TableCell>
                            <TableCell>Kunde</TableCell>
                            <TableCell>Rechnungsdatum</TableCell>
                            <TableCell>Fällig</TableCell>
                            <TableCell align="right">Betrag</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            [...Array(5)].map((_, index) => (
                                <TableRow key={index}>
                                    <TableCell colSpan={5}>
                                        <Skeleton variant="rectangular" height={24}/>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : nextDue.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    <Typography variant="body2" color="text.secondary">
                                        Keine offenen Fälligkeiten.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            nextDue.map((inv) => (
                                <TableRow key={inv.id} hover>
                                    <TableCell>{inv.invoiceNumber ?? "–"}</TableCell>
                                    <TableCell>
                                        {inv.customer
                                            ? `${inv.customer.name || ""} ${inv.customer.lastname || ""}`.trim()
                                            : "–"}
                                    </TableCell>
                                    <TableCell>
                                        {inv.invoiceDate
                                            ? new Date(inv.invoiceDate).toLocaleDateString("de-DE")
                                            : "–"}
                                    </TableCell>
                                    <TableCell>
                                        {inv.dueDate ? new Date(inv.dueDate).toLocaleDateString("de-DE") : "–"}
                                    </TableCell>
                                    <TableCell align="right">{fmtEUR(safeInvoiceTotal(inv))}</TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}
